import script from "./ModalProteccionDatos.vue?vue&type=script&setup=true&lang=ts"
export * from "./ModalProteccionDatos.vue?vue&type=script&setup=true&lang=ts"

import "./ModalProteccionDatos.vue?vue&type=style&index=0&id=492ade57&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-492ade57"]])

export default __exports__